import i18next from 'i18next';

import { DATE_DISPLAY_FORMATS } from '@commons/DatePickers/constants';
import { formatNumberForExport } from '../../common/utils';
import { makeXLS } from '@commons/utils/makeXLS';

export const generateExport = (tableData, currentPeriod, previousPeriod, selectedMetric) => {
  // Prepare headers
  const headers = [
    i18next.t('GENERAL.STORE'),
    `${i18next.t('ANALYSIS.PERFORMANCE.DINE_IN')} (${i18next.t(
      'ANALYSIS.PERFORMANCE.CURRENT_PERIOD',
    )})`,
    `${i18next.t('ANALYSIS.PERFORMANCE.DINE_IN')} (${i18next.t(
      'ANALYSIS.PERFORMANCE.PREVIOUS_PERIOD',
    )})`,
    `${i18next.t('ANALYSIS.PERFORMANCE.TAKEAWAY')} (${i18next.t(
      'ANALYSIS.PERFORMANCE.CURRENT_PERIOD',
    )})`,
    `${i18next.t('ANALYSIS.PERFORMANCE.TAKEAWAY')} (${i18next.t(
      'ANALYSIS.PERFORMANCE.PREVIOUS_PERIOD',
    )})`,
    `${i18next.t('ANALYSIS.PERFORMANCE.DELIVERY')} (${i18next.t(
      'ANALYSIS.PERFORMANCE.CURRENT_PERIOD',
    )})`,
    `${i18next.t('ANALYSIS.PERFORMANCE.DELIVERY')} (${i18next.t(
      'ANALYSIS.PERFORMANCE.PREVIOUS_PERIOD',
    )})`,
    `${i18next.t('GENERAL.TOTAL')} (${i18next.t('ANALYSIS.PERFORMANCE.CURRENT_PERIOD')})`,
    `${i18next.t('GENERAL.TOTAL')} (${i18next.t('ANALYSIS.PERFORMANCE.PREVIOUS_PERIOD')})`,
  ];

  // Prepare data rows
  const data = tableData.map((row) => [
    row.storeName,
    formatNumberForExport(row.eatin?.current),
    formatNumberForExport(row.eatin?.previous),
    formatNumberForExport(row.takeaway?.current),
    formatNumberForExport(row.takeaway?.previous),
    formatNumberForExport(row.delivery?.current),
    formatNumberForExport(row.delivery?.previous),
    formatNumberForExport(row.total?.current),
    formatNumberForExport(row.total?.previous),
  ]);

  // Create sheet
  const sheet = {
    title: i18next.t('ANALYSIS.PERFORMANCE.CHANNEL_DETAIL'),
    headers,
    data,
  };

  // Generate Excel file
  const fileName = `${i18next.t('ANALYSIS.PERFORMANCE.CHANNEL_DETAIL')} - ${
    selectedMetric.name
  } - ${currentPeriod.startDate.format(
    DATE_DISPLAY_FORMATS.SLASHED_DAY_MONTH_YEAR,
  )} - ${currentPeriod.endDate.format(
    DATE_DISPLAY_FORMATS.SLASHED_DAY_MONTH_YEAR,
  )} VS ${previousPeriod.startDate.format(
    DATE_DISPLAY_FORMATS.SLASHED_DAY_MONTH_YEAR,
  )} - ${previousPeriod.endDate.format(DATE_DISPLAY_FORMATS.SLASHED_DAY_MONTH_YEAR)}`;
  makeXLS(fileName, [sheet]);
};

export const generateExportDelivery = (
  tableData,
  currentPeriod,
  previousPeriod,
  selectedMetric,
) => {
  // Prepare headers
  const headers = [
    i18next.t('GENERAL.STORE'),
    `${i18next.t('ANALYSIS.PERFORMANCE.UBEREATS')} (${i18next.t(
      'ANALYSIS.PERFORMANCE.CURRENT_PERIOD',
    )})`,
    `${i18next.t('ANALYSIS.PERFORMANCE.UBEREATS')} (${i18next.t(
      'ANALYSIS.PERFORMANCE.PREVIOUS_PERIOD',
    )})`,
    `${i18next.t('ANALYSIS.PERFORMANCE.DELIVEROO')} (${i18next.t(
      'ANALYSIS.PERFORMANCE.CURRENT_PERIOD',
    )})`,
    `${i18next.t('ANALYSIS.PERFORMANCE.DELIVEROO')} (${i18next.t(
      'ANALYSIS.PERFORMANCE.PREVIOUS_PERIOD',
    )})`,
    `${i18next.t('ANALYSIS.PERFORMANCE.OTHER')} (${i18next.t(
      'ANALYSIS.PERFORMANCE.CURRENT_PERIOD',
    )})`,
    `${i18next.t('ANALYSIS.PERFORMANCE.OTHER')} (${i18next.t(
      'ANALYSIS.PERFORMANCE.PREVIOUS_PERIOD',
    )})`,
    `${i18next.t('ANALYSIS.PERFORMANCE.DELIVERY')} (${i18next.t(
      'ANALYSIS.PERFORMANCE.CURRENT_PERIOD',
    )})`,
    `${i18next.t('ANALYSIS.PERFORMANCE.DELIVERY')} (${i18next.t(
      'ANALYSIS.PERFORMANCE.PREVIOUS_PERIOD',
    )})`,
  ];

  // Prepare data rows
  const data = tableData.map((row) => [
    row.storeName,
    formatNumberForExport(row.ubereats?.current),
    formatNumberForExport(row.ubereats?.previous),
    formatNumberForExport(row.deliveroo?.current),
    formatNumberForExport(row.deliveroo?.previous),
    formatNumberForExport(row.other?.current),
    formatNumberForExport(row.other?.previous),
    formatNumberForExport(row.delivery?.current),
    formatNumberForExport(row.delivery?.previous),
  ]);

  // Create sheet
  const sheet = {
    title: i18next.t('ANALYSIS.PERFORMANCE.DELIVERY_DETAIL'),
    headers,
    data,
  };

  // Generate Excel file
  const fileName = `${i18next.t('ANALYSIS.PERFORMANCE.DELIVERY_DETAIL')} - ${
    selectedMetric.name
  } - ${currentPeriod.startDate.format(
    DATE_DISPLAY_FORMATS.SLASHED_DAY_MONTH_YEAR,
  )} - ${currentPeriod.endDate.format(
    DATE_DISPLAY_FORMATS.SLASHED_DAY_MONTH_YEAR,
  )} VS ${previousPeriod.startDate.format(
    DATE_DISPLAY_FORMATS.SLASHED_DAY_MONTH_YEAR,
  )} - ${previousPeriod.endDate.format(DATE_DISPLAY_FORMATS.SLASHED_DAY_MONTH_YEAR)}`;
  makeXLS(fileName, [sheet]);
};
